import { Component, Inject, OnInit, ViewEncapsulation, OnDestroy, PLATFORM_ID, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Device } from 'projects/common/model/Device';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { UtilsService } from 'projects/common/services/utils.service';
import { DOCUMENT } from '@angular/common';
import { FaqsService } from '../../../common/services/faqs.service';
import { LoaderComponent } from '@shopping-angular-components/loader';
import { Currency, LandingModel } from 'projects/common/model/landingModel';
import { PreHeadingService } from '../../../common/components/pre-heading/pre-heading.service';
import { VideoData, VideoPlayerService } from 'projects/common/services/video-player.service';
import { Module } from 'projects/common/model/ModuleModel';
import { ModuleService } from '../../../common/services/module.service';
import { MulticurrencyComponent } from '../../../common/components/multicurrency/multicurrency.component';
import { UpaService, UpaTarget } from '../../../common/services/upa.service';
import { MapModuleModel } from "../../../common/components/map-module/map-module.model";
import { isPlatformBrowser } from '@angular/common';
import { CustomTimmingsService } from 'projects/common/services/custom-timming-service.service';
import { SwipeToBuyService } from '../../../common/services/swipe-to-buy.service';
import { SwipeToBuy } from '../../../common/components/wizumen/wizumen-models';
import { SwipeToBuyModal } from '../../../common/components/wizumen/swipe-to-buy-modal/swipe-to-buy-modal.component';
import { SectionModulesService } from 'projects/common/services/sectionModules.service';
import { AdsBannersService } from 'projects/common/services/ads-banners.service';
import { Title } from '@angular/platform-browser';
import { HtmlUtilsService } from 'projects/common/services/html-utils.service';
import { GtmService } from 'projects/common/services/gtm.service';
import { BroadcastChannelService } from 'projects/common/services/broadcast-channel.service';
import { EmtpyStateService } from 'projects/common/services/empty-state.service';
import { SboxComponent } from 'projects/common/components/sbox/sbox.component';
import { ModulesFilterService } from 'projects/common/services/modules-filter.service';
import { ScrollService } from 'projects/common/services/scroll.service';

declare var window: any;

@Component({
  selector: 'app-root',
  template: `
    <modals-container *ngIf="!isIframe"></modals-container>
    <alerts-sac-modal *ngIf="hasPriceAlertsModule" [isMobile]="device.type === 'MOBILE'" [product]="landingModel.product" [flow]="landingModel.flow"></alerts-sac-modal>
    <video-player *ngIf="videoData?.showVideoPlayer" [videoData]="videoData" [screenType]="device.type"></video-player>
    <loyalty-switch
      *ngIf="!isAssistanceModalOpened && !landingModel.isCachedVersion"
      [upaTrackingData]="{moduleId: 'loyaltySwitch',moduleIndex: 0,target: UpaTarget.SWITCH}"
      [containerUniqueId]="'loyalty-redemption-switch'"
      [disableContainerStyles]="true" [flow]="landingModel.flow">
    </loyalty-switch>

    <div class="app-container {{device.type}} {{landingModel.distributionId}}" [style]="{'background-color': backgroundColor, '--background-color': backgroundColor}" [ngClass]="{'move-first-section': moveFirstSection}">
      <loader product="nymeria-gui" [white]="true" [show]="showLoader" [coverAll]="true" product="nymeria-gui" flow="landing"></loader>

      <div class="redirect-type-message" *ngIf="landingModel.redirectType && landingModel.distributionId === 'offersHubDynamic'">
        <div class="eva-3-container -wrapper">
          <eva-message *ngIf="landingModel.redirectType === 'SUBSCRIPTION'" [data]="{message_type: '-success', text: 'redirectMessage.subscription'}"></eva-message>
          <eva-message *ngIf="landingModel.redirectType === 'DEACTIVATED_LANDING'" [data]="{message_type: '-warning', icon: 'warning', text: 'redirectMessage.deactivatedLanding'}"></eva-message>
        </div>
      </div>
      <!-- TODO check -->

      <header-wrapper *ngIf="hasHeader()"
                      [sboxModule]="sboxModule" [backgroundModule]="backgroundModule"  [mainTitleModule]="mainTitleModule"
                      [productMainTitleModule]="productMainTitleModule"
                      [module]="headingModule" [mapModule]="mapModule"
                      [product]="landingModel.product" [flow]="landingModel.flow" [shifuProduct]="shifuProduct"
      ></header-wrapper>

      <input-text-filter *ngIf="inputTextFilterModule" [module]="inputTextFilterModule"></input-text-filter>

      <div id="{{module.unique_id}}" class="nymeria-module"
           [ngStyle]="resolveBackgroundModule(module)"
           *ngFor="let module of modules | slice: 0 : modulesToRender; let i = index; trackBy: moduleOriginalId">
           <meta-component *ngIf="!module.ajax || deferredModulesLoaded" [module]="module" [containerId]="LANDING_TOPIC"
                          [currency]="currency" [device]="device" [product]="landingModel.product" [flow]="landingModel.flow" 
                          [locale]="locale" [isLastSSRModule]="isLastSSRModule(i)" [onLastLoadedCallback]="onLastLoadedCallback"
                          [hasActivePriorityEvent]="landingModel.hasActivePriorityEvent"></meta-component>
           <skeleton *ngIf="!showSkeleton && module.ajax && !deferredModulesLoaded && !module.hidden" [skeletonIndex]="ajaxModulesUniqueIds ? ajaxModulesUniqueIds.indexOf(module.unique_id || '') : 0"></skeleton>
      </div>

      <!-- SKELETON SSR -->
      <skeleton *ngIf="showSkeleton"></skeleton>
        <div class="breadcrumb-wrapper-fullwidth" *ngIf="breadcrumbModule?.data">
          <div 
            [ngClass]="{
              'eva-3-container -eva-3-mt-lg': device.type === 'DESKTOP'
            }"
          >
            <div [class.breadcrumb-footer]="device.type !== 'DESKTOP'">
              <breadcrumb-component [data]="breadcrumbModule?.data"></breadcrumb-component>
            </div>
          </div>
        </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
  readonly LANDING_TOPIC = UpaService.LANDING_TOPIC;
  mediaPicturePrefix = '//media.staticontent.com/media/pictures/';
  title = 'dynamic';
  headingModule: any;
  breadcrumbModule: any;
  backgroundModule: any;
  sboxModule: any;
  mainTitleModule: any;
  productMainTitleModule: any;
  inputTextFilterModule: any;
  backgroundColor: any;
  mapModule?: Module<MapModuleModel>;
  device: Device;
  currency: Currency;
  landingModel: LandingModel;
  showLoader: boolean;
  moveFirstSection = false;
  videoData: Required<VideoData>;
  modules: Module[];
  showSkeleton: boolean;
  deferredModulesLoaded = false;
  modulesToRender: number | undefined;
  viewInitialized: boolean;
  startTime: number;
  productSectionInitialized = true;
  productChangeEventTime: any;
  productChangeTimming: any;
  locale: string;
  isIframe: boolean;
  hasPriceAlertsModule = false;
  shifuProduct = "";
  updatedSbox = false;
  isLoadingSectionModules = false;
  isAssistanceModalOpened = false;
  ajaxModulesUniqueIds: string[];
  localWebviewChannel: BroadcastChannel;
  broadcastListenersAdded: boolean = false;
  lastNonAjaxModuleIndex: number = -1;

  private subscriptions: any[] = [];
  private cookieChannels: BroadcastChannel[] = [];

  constructor(@Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
    public landingModelService: LandingModelService,
    public utilsService: UtilsService,
    private translate: TranslateService,
    private faqsService: FaqsService,
    private videoPlayerService: VideoPlayerService,
    private preHeadingService: PreHeadingService,
    private moduleService: ModuleService,
    private upaService: UpaService,
    private customTimmingsService: CustomTimmingsService,
    private swipeToBuyService: SwipeToBuyService,
    private sectionModulesService: SectionModulesService,
    private emptyStateService: EmtpyStateService,
    private adsBannersService: AdsBannersService,
    private titleService: Title,
    private htmlUtilsService: HtmlUtilsService,
    private gtmService: GtmService,
    private changeDetector: ChangeDetectorRef,
    private modulesFilterService: ModulesFilterService
  ) { }

  ngOnInit(): void {
    this.landingModel = this.landingModelService.getLandingModel();

    if (this.landingModel.isCachedVersion) {
      if (isPlatformBrowser(this.platformId)) {
        window.skipAppMetrics = true;
      }
      this.mediaPicturePrefix = 'https://media.staticontent.com/media/pictures/';
    }

    this.isIframe = this.landingModel.distributionId === 'dynamicIframe';

    this.initCustomTimmingsListeners();

    this.videoData = this.videoPlayerService.videoData as Required<VideoData>;

    this.modules = this.getModulesToRender(this.landingModel.modules);
    this.lastNonAjaxModuleIndex = this.getLastRenderableModuleIndex();

    this.hasPriceAlertsModule = this.modules.some(module => module.id === 'PriceAlertsBannerModule');

    this.subscriptions.push(this.landingModelService.modulesUpdatedEvent.subscribe((modules: Module[]) => this.modules = this.getModulesToRender(modules)));

    this.locale = this.landingModelService.getLocale();
    this.device = this.landingModel.device;
    this.updateModules();

    this.backgroundColor = this.landingModel.mainBackgroundColor;
    this.currency = this.landingModel.currency;

    this.subscriptions.push(LoaderComponent.showLoaderEvent.subscribe((state: boolean) => this.showLoader = state));
    this.subscriptions.push(MulticurrencyComponent.currencyEvent.subscribe((event) => this.currency = event));

    this.setupTranslateService(this.landingModel);
    this.insertMarkupFAQsScript();

    if (!this.isIframe) {
      this.upaService.trackPageview();
    }

    if (!isPlatformBrowser(this.platformId)) {
      if (this.isFullSSR()) {
        this.showSkeleton = false;
        this.modulesToRender = this.modules.length;
      } else {
        const modulesRenderInServer = this.landingModel.modulesRenderInServer;
        this.showSkeleton = modulesRenderInServer != null && this.modules.length > modulesRenderInServer;
        this.modulesToRender = modulesRenderInServer;
      }
      
    } else {
      const upaData = window.upaData;
      window.landingContext = this.landingModel.context;

      this.listenCookiesBroadcastChannel(this.landingModel.cookiesTowatch?.length > 0 ? this.landingModel.cookiesTowatch : ["jetski-checkin"]);
      this.listenCurrencyChange();
      this.listenSboxMount();

      this.loadAjaxModulesAndTrack();

      if (upaData?.fl == 'home') {
        if (this.landingModel.webview) {
          this.localWebviewChannel = BroadcastChannelService.initializeChannel();
          BroadcastChannelService.listenToLocalWebviewEvents(this.localWebviewChannel, this.landingModel.isCachedVersion, '.nymeria-module');
        }

        this.listenSboxUpdated();
        const ProductSectionCache = {
          modules: this.modules,
          trackers: { pr: upaData.pr, searchid: upaData.searchid, ab: upaData.ab },
          google_ads: this.landingModel.googleAds,
          tags: { title: this.titleService.getTitle() || "" },
          new_relic_data: this.landingModel.trackingGtm,
          is_from_browser_cache: false,
          is_from_server_cache: this.landingModel.newRelicData.tracking_info.cacheResponse
        }
        this.sectionModulesService.saveInitialProductSectionCache(this.shifuProduct, window.location.pathname, ProductSectionCache);
        this.listenProductChange();
      }

      if (window.newrelic) {
        window.addEventListener("load", () => {

          if (upaData?.fl == 'home' && upaData?.dtype == 'DESKTOP') {
            this.htmlUtilsService.checkVisibleElementOrThrowError('.sbox5-layout');
          }

          try {
            window.newrelic.setCustomAttribute("hotjar", performance.getEntriesByType('resource').some((r) => /hotjar\.com/.test(r.name)));
          } catch (e) { }
        });
      }
    }

    if (isPlatformBrowser(this.platformId) && window.location.search) {
      const scrollTarget = new URLSearchParams(window.location.search).get('scroll');
      if (scrollTarget) {
        setTimeout(() => {
        ScrollService.scrollToElement(this.document.getElementById(scrollTarget));
        }, 1500);
      }
    }
  }

  getLastRenderableModuleIndex(): number {
    const limit = this.isFullSSR() ? this.modules.length : this.landingModel.modulesRenderInServer;
      return this.modules
        .slice(0, limit)
        .reduce((lastIndex, module, index) => {
          return (!module.ajax) ? index : lastIndex;
        }, -1);
  }

  isFullSSR() {
    return this.landingModel.isCachedVersion || (this.landingModel.isBot && !this.landingModel.webview);
  }

  isLastSSRModule(moduleIndex) {
    return moduleIndex === this.lastNonAjaxModuleIndex;
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId) && !this.productSectionInitialized) {
      if (this.productChangeTimming.selectedProduct === this.shifuProduct) {
        const endTime = performance.now();
        const sectionTime = endTime - this.productChangeEventTime;
        this.customTimmingsService.trackProductChangePageLoad(this.productChangeTimming, sectionTime);
        this.productSectionInitialized = true;
      }
    }
  }

  initCustomTimmingsListeners() {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('beforeunload', () => {
        // TODO add condition to track bounce
        this.customTimmingsService.trackBounce();

        const upaData = this.upaService.resolveData({
          label: (new Date().getTime() - window.performance.timing.fetchStart).toString(),
          eventtype: 'user-leaves',
          target: UpaTarget.TIMMINGS,
          uniqueId: undefined, moduleId: '', moduleIndex: 0
        });
        this.upaService.trackTopic(this.LANDING_TOPIC, upaData);
      });
    }
  }

  updateModulesByAjax() {
    this.landingModel.modules = window.landingModules;
    this.modules = this.getModulesToRender(this.landingModel.modules);
    this.updateModules();
    this.showSkeleton = false;
    this.changeDetector.detectChanges();
  }

  loadAjaxModulesAndTrack() {
    const hasSomeAjaxModule = this.modules.find(module => module.ajax);

    const isAllLazyLoad = this.landingModel.abTests?.tests?.["CargaProgresiva-HotelByCity"]?.ajax == "true";

    if (isAllLazyLoad) {
      this.showSkeleton = true;

      if (window.landingModules != null) {
        this.updateModulesByAjax();
        hasSomeAjaxModule && this.getDeferredLoadModulesData();
      } else {
        window.addEventListener("ajaxModulesLoaded", () => {
          this.updateModulesByAjax();
          hasSomeAjaxModule && this.getDeferredLoadModulesData();
        });

      }
    }

    if (!isAllLazyLoad && hasSomeAjaxModule) {
      this.getDeferredLoadModulesData();
    }


    if (!isAllLazyLoad && !hasSomeAjaxModule) {
      this.upaService.trackModulesView();
    }

  }

  listenProductChange() {
    globalThis.document.addEventListener("productChange", (event: any) => {
      this.productChangeEventTime = performance.now();
      this.updatedSbox = false;
      this.updateSectionModules(event.detail);
    });
    globalThis.document.addEventListener("cleanCacheAjaxSboxNymeria", (event: any) => {
      this.sectionModulesService.cleanCache();
    });
  }

  listenSboxUpdated() {
    globalThis.document.addEventListener("updatedSbox", (event: any) => {
      this.updatedSbox = true;
      this.toggleHomeLoader();

      // ALERTA PARA CUANDO HAY MAS DE UNA CAJA REDUCIDA DIBUJADA
      if (isPlatformBrowser(this.platformId) && 'MOBILE' == this.device.type.toString()) {
        const sboxReducedContainers = document.querySelectorAll('.sbox5-layout');
        if (sboxReducedContainers.length > 1 && window.newrelic != null) {
          this.htmlUtilsService.trackErrorToNR('.sbox5-layout', 'duplicated-mobile');
        }
      }
    });
  }

  listenCurrencyChange() {
    globalThis.document.addEventListener("shifu-currency-change", (event: any) => {
      window.location.reload();
    });
  }

  listenSboxMount() {
    const nevoModule = this.landingModel.modules.find(module => module.id === 'NevoModule');
    const sboxInitConfig = nevoModule?.data?.sbox_init_config;
    sboxInitConfig && (sboxInitConfig.origin = UtilsService.keysToCamel(sboxInitConfig.origin));
    sboxInitConfig && (sboxInitConfig.destination = UtilsService.keysToCamel(sboxInitConfig.destination));
    
    if (sboxInitConfig && !window.searchbox?.sboxLoaded) {
      globalThis.document.addEventListener(SboxComponent.FINISH_MOUNT_EVENT, () => {
        window.searchbox.updateProps(sboxInitConfig); 
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
    this.localWebviewChannel?.close();
    this.cookieChannels?.forEach(channel => channel.close());
  }

  hasHeader(): boolean {
    return this.headingModule != null || this.backgroundModule != null || this.breadcrumbModule != null || this.sboxModule != null || this.mainTitleModule != null;
  }

  resolveBackgroundModule(module: any) {
    if (module.id === "WizumenModule") {
      if (module.data && module.data.background_module) {
        delete module.data.background_module;
      }
    }
    return [module, module?.data].find((x) => x?.background_module?.type == 'FULL_WIDTH') ? this.moduleService.resolveBackgroundModule(module, this.device) : {};
  }

  private getModulesToRender(modules: Module[]): Module[] {
    const visibleModules = this.getVisibleModules(modules);
    this.emptyStateService.analyzeEmptyStates(visibleModules, this.LANDING_TOPIC);
    visibleModules.sort((a, b) => a.position - b.position);
    return (visibleModules[0].id === 'NevoModule') ? visibleModules.slice(1) : visibleModules;
  }

  private getVisibleModules(modules: Module[]): Module[] {
    return modules.filter(m => !m.hidden || m.ajax) // hidden en realidad es para no procesar el módulo. si es hidden + ajax, se procesa pero no muestra skeleton
  }

  private setNavSelectedProduct(): void {
    const nevoModuleProduct = this.getNavSelectedProduct();
    if (nevoModuleProduct) {
      this.document.body.setAttribute('product', nevoModuleProduct);
      this.shifuProduct = nevoModuleProduct;
    }
  }

  private getNavSelectedProduct(): string {
    const nevoModule = this.landingModel.modules.find(module => module.id === 'NevoModule');
    if (nevoModule?.data?.nav_product) {
      return nevoModule.data.nav_product.toLowerCase();
    }
    return "";
  }

  private updateModules(isSectionLoad = false): void {
    this.setNavSelectedProduct();

    this.modules.forEach((module: any) => {
      switch (module.id) {
        case 'HeadingModule':
          if (module.data){
            if (module.data.breadcrumbs?.length > 0) {
              this.breadcrumbModule = {data: module.data.breadcrumbs};
            }
            this.moveFirstSection = module.data.move_first_section;
            if (!isSectionLoad || !this.headingModule){
              this.headingModule = module;
            } else {
              this.updateHeadingModuleExceptSbox(module);
            }
          }
          break;
        case 'BackgroundModule':
          this.backgroundModule = module;
          break;
        case 'BreadCrumbsModule':
          this.breadcrumbModule = module;
          break;
        case 'SBoxModule':
          if (module.data?.ubication === 'HEADER') {
            if (!isSectionLoad) {
              this.sboxModule = module.data;
            }
          }
          break;
        case 'MainTitleModule':
          this.mainTitleModule = module;
          break;
        case 'ProductMainTitleModule':
          this.productMainTitleModule = module;
          break;
        case 'InputTextFilterModule':
          if (this.modules) {
            this.modulesFilterService.setModules(this.modules);
          }
          if (module.data.ubication === 'TOP') {
            this.inputTextFilterModule = module;
            this.modules = this.modules.filter(m => m.id !== 'InputTextFilterModule');
          }
          break;
        case 'PreHeadingModule':
          if (isPlatformBrowser(this.platformId) && !globalThis.document.getElementById('PreHeadingComponent')) {
            this.preHeadingService.createComponent(module);
          }
          break;
        case 'HotelMapModule':
          this.mapModule = module;
          break;
        case 'AssistanceModalModule':
          if (isPlatformBrowser(this.platformId)) {
            this.showAssistanceModalOfferIfApply()
          }
          break;
      }
    });
  }

  private setupTranslateService(landingModel: LandingModel): void {
    const langCode = landingModel.language;
    this.translate.setDefaultLang(langCode);
    this.translate.use(langCode);
  }

  private insertMarkupFAQsScript() {
    if (globalThis.document) {
      const markedUpFaqs = this.faqsService.getMarkedUpFaqs(this.modules);
      markedUpFaqs.forEach(markedUpFaq => {
        const scriptTag = globalThis.document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.innerHTML = JSON.stringify(markedUpFaq);
        globalThis.document.body.appendChild(scriptTag);
      });
    }
  }

  private updateSectionModules(eventDetail: { name: string, url: string, pvid: string }) {
    this.isLoadingSectionModules = true;

    const url = new URL(eventDetail.url).pathname;
    const selectedProduct = eventDetail.name;
    this.toggleHomeLoader();
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.deferredModulesLoaded = false;
    this.productChangeTimming = {};

    this.sectionModulesService.getSectionProductModules(url, selectedProduct)
      .then(sectionModulesResponse => {
        if (sectionModulesResponse.modules) {
          this.updateUpaData(eventDetail.pvid, sectionModulesResponse.trackers?.upa_data?.pr, sectionModulesResponse.trackers?.upa_data?.searchid);
          this.upaService.trackPageview();
          if (window.UpaDataTracker) {
            window.UpaDataTracker.send(window.upaData);
          }
          this.adsBannersService.initAds();
          this.landingModelService.updateGoogleAds(sectionModulesResponse.google_ads);

          this.landingModel.modules = sectionModulesResponse.modules;
          this.modules = this.getModulesToRender(this.landingModel.modules);
          this.updateModules(true);

          const hasSomeAjaxModule = this.modules.find(module => module.ajax);
          if (hasSomeAjaxModule) {
            this.loadSectionAjaxModules(url, selectedProduct);
          } else {
            this.upaService.trackModulesView();
          }

          if (sectionModulesResponse.tags?.title) {
            this.titleService.setTitle(sectionModulesResponse.tags.title);
          }
          this.productChangeTimming = {
            selectedProduct: selectedProduct,
            fromServerCache: sectionModulesResponse.is_from_server_cache.toString(),
            fromBrowserCache: sectionModulesResponse.is_from_browser_cache.toString(),
            pageViewId: eventDetail.pvid
          };
        }
      }).finally(() => {
        this.isLoadingSectionModules = false;
        this.toggleHomeLoader();
        this.productSectionInitialized = false;
      });

  }

  updateHeadingModuleExceptSbox(module) {

    Object.keys(module).forEach(key => {
      if (key !== 'data' && this.headingModule[key]) {
        this.headingModule[key] = module[key];
      }
    });

    Object.keys(module.data).forEach(key => {
      if (key !== 'sbox' && this.headingModule.data[key]) {
        this.headingModule.data[key] = module.data[key];
      }
    });

  }

  private loadSectionAjaxModules(url: string, selectedProduct: string) {

    this.sectionModulesService
      .getAjaxModulesData(url, selectedProduct)
      .then(jsonResponse => {
        this.updateDeferredLoadModules(jsonResponse.modules || []);
      })
      .catch(error => {
        this.updateDeferredLoadModules([]);
      });
  }

  private updateDeferredLoadModules(ajaxModules: Module[]) {
    const noAjaxModules = this.landingModel.modules.filter((module) => !module.ajax);
    this.modules = noAjaxModules.concat(ajaxModules).sort((a, b) => a.position - b.position);
    this.landingModelService.updateModules(this.modules);
    this.updateModules();
    this.deferredModulesLoaded = true;
    this.changeDetector.detectChanges(); // forzamos la detección de cambios para que no se cuelgue con los skeletons
    this.upaService.trackModulesView();
  }

  private getDeferredLoadModulesData() {

    const initialProduct = this.shifuProduct;
    if (window.deferredLoadModules != null && Array.isArray(window.deferredLoadModules) && window.deferredLoadModules.length) {
      this.updateDeferredLoadModules(window.deferredLoadModules);

    } else {
      this.ajaxModulesUniqueIds = this.modules.filter(module => module.ajax).map(module => module.unique_id || '');

      window.addEventListener("deferredModulesLoaded", () => {
        if (this.shifuProduct === initialProduct) {
          this.updateDeferredLoadModules(window.deferredLoadModules);
        }
      });
      window.addEventListener("deferredModulesError", () => {
        if (this.shifuProduct === initialProduct) {
          this.updateDeferredLoadModules([]);
        }
        console.error("Ajax Modules error");
      });
    }
  }

  private showAssistanceModalOfferIfApply() {
    const assistanceModalModule = this.landingModel.modules.find(el => el.id === SwipeToBuyModal.MODULE_ID);
    if (!assistanceModalModule) return;

    const assistance: SwipeToBuy = assistanceModalModule.data;

    this.isAssistanceModalOpened = true;
    this.swipeToBuyService.openModal({
      ...(assistance?.upa_data || {}),
      moduleId: assistanceModalModule.id,
      moduleIndex: assistanceModalModule.position,
      uniqueId: assistanceModalModule.unique_id || assistanceModalModule.id,
      flow: this.landingModel.flow
    }, assistance)
  }

  moduleOriginalId(index: number, item: Module) {
    return item.unique_id || index;
  }

  castModule<M extends Module, T extends M>(module: M): T {
    return module as T;
  }

  toggleHomeLoader() {
    this.showLoader = this.isLoadingSectionModules || !this.updatedSbox;
    if (this.showLoader) {
      globalThis.document.body.classList.add('nym-lock-scroll');
    } else {
      globalThis.document.body.classList.remove('nym-lock-scroll');
    }
  }

  updateUpaData(pageview_id, pr, searchid) {
    window.upaData.pageview_id = pageview_id;
    window.upaData.pr = pr;
    window.upaData.searchid = searchid;
    this.gtmService.trackShoppingData(true);
  }

  listenCookiesBroadcastChannel(cookiesToWatch: string[]) {
    if (!this.landingModel.webview) return;

    cookiesToWatch?.forEach(cookieName => {
      const bc = new BroadcastChannel(cookieName);
      bc.onmessage = () => {
        const userCookies = document.cookie.split(';').map((cookie: string) => cookie.trim());
        if (userCookies.some((cookie) => cookie.includes(cookieName))) {
          location.reload();
        }
      };
      this.cookieChannels.push(bc);
    });
  }

  onLastLoadedCallback = () => {
    if (isPlatformBrowser(this.platformId) && !this.landingModel.isCachedVersion && this.landingModel.webview && !this.broadcastListenersAdded) {
      console.log('onLastLoadedCallback called in AppComponent');
      this.broadcastListenersAdded = true;
      BroadcastChannelService.sendLandingLoadedMessage(this.localWebviewChannel);
    }
  }

  protected readonly UpaTarget = UpaTarget;
}
